import axiosInstance from "./axios";
import { PackageDto } from "../types/package.types";

export const getPackages = async (): Promise<PackageDto[]> => {
  try {
    console.log("[DEBUG] Fetching packages from /package");
    const response = await axiosInstance.get<PackageDto[]>("package");
    console.log("[DEBUG] Packages response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("[DEBUG] Error fetching packages:", error.response?.status, error.response?.data, error.message);
    throw error;
  }
};

export const acceptPackage = async (packageId: number): Promise<any> => {
  try {
    console.log("[DEBUG] Accepting package with ID:", packageId);
    const response = await axiosInstance.post(`package/${packageId}/accept`, {});
    console.log("[DEBUG] Package acceptance response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("[DEBUG] Error accepting package:", error.response?.status, error.response?.data, error.message);
    throw error;
  }
};
export const purchasePackage = async (packageId: number) => {
  const res = await axiosInstance.post(`/Purchase/package`, { id: packageId });
  return res.data;
};
